import DataExport from "../singleton/data-export";

export default {

    run: DataExport.run.bind(DataExport),

    getFieldsOptions: DataExport.getFieldsOptions.bind(DataExport),

    Template: {

        getAll: DataExport.getAll.bind(DataExport),
    
        get: DataExport.get.bind(DataExport),

        delete: DataExport.delete.bind(DataExport),

        setOrder: DataExport.setOrder.bind(DataExport)

    }

}